import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PortSelectComponent } from './port-select.component';
import { TranslocoModule } from '@jsverse/transloco';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { FormErrorModule, SelectModule } from '@eg/ui';

@NgModule({
  declarations: [PortSelectComponent],
  imports: [CommonModule, SelectModule, TranslocoModule, FlexLayoutModule, FormErrorModule],
  exports: [PortSelectComponent],
})
export class OriginPortModule {}
